export default __webpack_public_path__ + "static/media/swipe.4c69cf47.svg";